
import FaqWeb from "./FaqWeb"
import FaqMob from "./FaqMob";
import { Grid2,Box, Typography, Button, Accordion, AccordionSummary, AccordionDetails, Divider, List, ListItem, ListItemText,useMediaQuery,TextField,MenuItem } from "@mui/material"
import { useNavigate, useLocation } from "react-router-dom";
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import { useState,useEffect,useRef } from "react";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline'
import HighlightOffIcon from '@mui/icons-material/HighlightOff'
import axios from "axios";
import Styles from "./FaqList.module.css"
import CategoryBar from "./CategoryBar";
import { backendHosts } from "../../../ui-utils/apiConfig"


export default function FaqWebList({ categoryId, categoryName, searchCategoryId, searchSubCategoryId, searchFaqId }){



    function slugify(title) {

        return title
            ?.toLowerCase()
            ?.replace(/[^\w\s-]/g, "")
            ?.replace(/\s+/g, "-")
            ?.replace(/-+/g, "-")
            ?.replace(/^-+|-+$/g, "");
    }

    const history = useNavigate()
    const location = useLocation()

    const faqRefs = useRef({})

    const [selected, setSelected] = useState(0)
    const [expanded, setExpanded] = useState(null)
    const [subCategory, setSubCategory] = useState([])
    const [faqsList, setFaqsList] = useState([])
    const [subSelectValue, setSubSelectValue] = useState('')
    const [fadId, setFaqId] = useState(null)
    const [relatedFaqs, setRelatedFaqs] = useState([])
    const [activeIndex, setActiveIndex] = useState(0);
    const [categories,setCategories]=useState([]);
    const [value, setValue] = useState('')

    const isSmallScreen = useMediaQuery("(max-width:900px)")
    const isSmallScreen600 = useMediaQuery("(max-width:600px)")

     const [storedCategory, setStoredCategory] = useState(() => {
            return localStorage.getItem("category");
        });



    useEffect(() => {
        // console.log("fetching category")
        (async () => {

            try {
                const result = await axios.get(`${backendHosts.ADMIN}/api/faqs/categories`)

                if (result.data.status == 200) {
                    const subResults = result.data?.categories
                    setCategories(subResults)



                } else {
                    console.log("Error in fetching category list API: ", result)
                }

            } catch (error) {
                console.log("Error in fetching category list API: ", error)
            }
        })()

        const pathParts = location.pathname.split("/");

        if (pathParts.length > 4) {
            const newPath = `/${pathParts[1]}/${pathParts[2]}/${pathParts[3]}`;

            history(newPath, {
                replace: true,
                state: location.state
            });
        }
    }, [])

    // alert("1")
    useEffect(() => {
        // console.log("available")
        // Only proceed if categoryId OR searchCategoryId is available
        if (!categoryId && !searchCategoryId) return;

        if (categoryName) {

            const matchedIndex = categories.findIndex(cat => cat?.name === categoryName.toUpperCase());

            if (matchedIndex !== -1) {

                setActiveIndex(matchedIndex);
            }
        }

        (async () => {

            try {
                const result = await axios.get(`${backendHosts.ADMIN}/api/faqs/categories/${categoryId || searchCategoryId}`)
                // const result = await ({
                //     endPoint: `/api/faqs/categories/${categoryId || searchCategoryId}`,
                //     method: "get",
                //     instance: "instanceFive"
                // });

                if (result.data?.status === 200) {
                    const subResults = result.data.data?.subcategories;

                    setSubCategory(subResults);
                    // setFaqsList(result.data.data?.subcategories)

                    if (searchSubCategoryId) {
                         console.log("1")
                        const selectedSub = subResults.find((item) => item.id === searchSubCategoryId)
                        const slug = slugify(selectedSub?.name)
                        setSubSelectValue(slug)
                        handleListFaqs(searchSubCategoryId);
                        setValue(selectedSub.name)
                        setSelected(searchSubCategoryId);
                    } else if (subResults.length > 0) {
                        const storedSubcategoryId = Number(localStorage.getItem("subcategoryId"));


                        if (storedSubcategoryId) {
                            console.log("2")
                            const foundSubcategory = subResults.find(sub => sub.id === storedSubcategoryId)
                            const slug = slugify(foundSubcategory?.name)
                            setSubSelectValue(slug)
                            setValue(foundSubcategory.name)
                            setSelected(storedSubcategoryId);
                            handleListFaqs(storedSubcategoryId);
                        } else {
                            console.log("3")
                            const defaultSub = subResults[0];
                            const slug = slugify(defaultSub?.name)
                            setSubSelectValue(slug)
                            setValue(defaultSub.name)
                            setSelected(defaultSub.id);
                            handleListFaqs(defaultSub.id);
                        }
                    }else{
                        setFaqsList([])
                    }

                } else {
                    console.log("Error in fetching subcategory list API: ", result);
                }
            } catch (error) {
                console.log("Error in fetching subcategory list API: ", error);
            }
        })();
    }, [categoryId, searchCategoryId, searchSubCategoryId, searchFaqId]);

    useEffect(() => {

        // console.log("fetching related FAQs")
        if (fadId || searchFaqId) {
            (async () => {
                try {
                    const result = await axios.get(`${backendHosts.ADMIN}/api/faqs/questions-and-answers/${fadId || searchFaqId}/related`)
                    // const result = await httpRequest({
                    //     endPoint: `/api/faqs/questions-and-answers/${fadId || searchFaqId}/related`,
                    //     method: "get",
                    //     instance: "instanceFive"
                    // });

                    if (result.data?.status === 200) {
                        const subResults = result.data?.data;
                        setRelatedFaqs(subResults);
                    } else {
                        console.log("Error in fetching related FAQs list API: ", result);
                    }
                } catch (error) {
                    console.log("Error in fetching related FAQs list API: ", error);
                }
            })()
        }
    }, [fadId, searchFaqId])





    // useEffect(() => {
    //     const handleStorageChange = () => {
    //         const newCategory = localStorage.getItem("category");
    //         setStoredCategory(newCategory);

    //     };

    //     window.addEventListener("storage", handleStorageChange);

    //     return () => {
    //         window.removeEventListener("storage", handleStorageChange);
    //     };
    // }, []);

    // useEffect(() => {
    //     const newCategory = localStorage.getItem("category");
    //     if (newCategory) {
    //         const matchedIndex = categories.findIndex(cat => cat.name === newCategory);
    //         if (matchedIndex !== -1) {
    //             setActiveIndex(matchedIndex);
    //         }
    //     }
    // }, [storedCategory]);




    const handleListFaqs = async (id) => {

        localStorage.setItem("subcategoryId", id)
        try {
            const result = await axios.get(`${backendHosts.ADMIN}/api/faqs/subcategories/${id}/faqs`)
            // const result = await httpRequest({
            //     endPoint: `/api/faqs/subcategories/${id}/faqs`,
            //     method: "get",
            //     instance: "instanceFive"
            // })

            if (result.data.status == 200) {
                const faqResults = result.data?.data.faqs
                setFaqsList(faqResults)

                if (searchFaqId) {
                    const matchIndex = faqResults.findIndex(f => f.id === searchFaqId);
                    if (matchIndex !== -1) {
                        setExpanded(matchIndex); // <-- auto expand
                        setTimeout(() => {
                            faqRefs.current[searchFaqId]?.scrollIntoView({ behavior: "smooth", block: "start" });
                        }, 200); // scroll after slight delay
                    }
                }
            } else {
                console.log("Error in fetching Faqs list API: ", result)
            }
        } catch (error) {
            console.log("Error in fetching Faqs list API: ", error)
        }
    }

    const handleChange = (isExpanded, index) => {
        setExpanded(isExpanded ? index : null);
    }

    const handleChangeDropDown =(event)=>{
        const selectedName = event.target.value;
        setExpanded(null)
        setValue(selectedName)
        handleSubCategoryRoute(selectedName)

        const selectedSub = subCategory.find((item) => item.name === selectedName);
        if (selectedSub) {
            handleListFaqs(selectedSub.id); // call API with new selection
        }
    }

    const handleSubCategoryRoute = (subCategory) => {
        const slug = slugify(subCategory)
        setSubSelectValue(slug)

        history(`/support/faqs/${categoryName}/${slug}`)
    }

    const handleSubCategoryFaqRoute = (faq) => {
        const slug = slugify(faq)

        history(`/support/faqs/${categoryName}/${subSelectValue}/${slug}`)
    }

    const handleBackClick = () => {
        history('/support/faqs')
    }

    const handleCreateTicket = () => {
        history('/support/contact')
        window.scrollTo(0, 0)
    }

    const handleFaqClick = (faq) => {

        const name = slugify(faq.category.name)
        const subCategory = slugify(faq.subcategory.name)
        const question = slugify(faq.question)

        localStorage.setItem("subcategoryId", faq.subcategory_id)
        localStorage.setItem("categoryId", faq.category_id)

        history(`/support/faqs/${name}/${subCategory}/${question}`, {
            state: {
                searchCategoryId: faq.category_id,
                searchSubCategoryId: faq.subcategory_id,
                searchFaqId: faq.id
            }
          });
    }
    return (<main>
        <Grid2 className={Styles.page_wrapper}>

        {  isSmallScreen ? <FaqMob /> : <FaqWeb />}
        {/* {
                isSmallScreen ? <></> : <> <div className={Styles.category_bar_wrapper}>
                    <CategoryBar activeIndex={activeIndex} setActiveIndex={setActiveIndex} storedCategory={storedCategory} setCategories={setCategories} categories={categories} setFaqsList={setFaqsList} />
                </div></>
        } */}


        <Grid2 container className={Styles.bxcntr_one}>
            {/* Left Sidebar (Jump to) */}

            {
                isSmallScreen600 ? <>
                        <Grid2 container
                            spacing={2} xs={12} md={3}
                            sx={{
                                pr: 2, display: "flex", flexDirection: "column", minWidth: "200px"
                                , "@media screen (max-width:900px)": {
                                    flexDirection: "row",
                                    minWidth: "0px"
                                }
                            }}

                        >


                            {
                                isSmallScreen ? <>
                                    <Grid2 container display="flex" justifyContent="space-between">
                                        <Grid2 item>
                                            <Typography className={Styles.jmptotxt}>
                                                Jump to
                                            </Typography>
                                        </Grid2>

                                        <Grid2 item sx={{ paddingTop: "5px" }}>
                                            <Button
                                                onClick={handleBackClick}
                                                variant="text"
                                                sx={{
                                                    padding: '0px 0px',
                                                    textTransform: 'none',
                                                    fontFamily: 'Inter600',
                                                    fontWeight: 400,
                                                    fontSize: 'calc(20px + var(--font-delta))',
                                                    color: '#CB2F3F',
                                                    '&:hover': {
                                                        backgroundColor: 'transparent',
                                                    },
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                }}
                                            >
                                                <ArrowBackIcon sx={{ marginRight: '8px', color: '#CB2F3F' }} />
                                                Back
                                            </Button>
                                        </Grid2>
                                    </Grid2>
                                </> : <>
                                    <Typography className={Styles.jmptotxt} >
                                        Jump to
                                    </Typography>
                                </>
                            }
                            {/* */}


                            {/* <Grid2 container spacing={2} >
                                {subCategory.map((category, index) => (
                                    <Grid2 item key={category.id}>
                                        <Button
                                            onClick={() => {
                                                setExpanded(null)
                                                setSelected(category.id);
                                                handleListFaqs(category.id);
                                                handleSubCategoryRoute(category.name)
                                            }}
                                            sx={{
                                                width: "210px",
                                                height: category.id === selected ? "70px" : "48px",
                                                borderRadius: "16px",
                                                textTransform: "capitalize",
                                                border: "1px solid #D3D3D3",

                                                fontFamily:
                                                    category.id === selected ? "Inter600" : "Inter400",
                                                color: "#000000",
                                                background: category.id === selected ? "#D7FFF4" : "#FFFFFF",
                                                marginBottom: "15px",
                                                boxShadow: category.id === selected ? "0px 4px 62px 0px #00000040" : "",

                                                "&:hover": {
                                                    background: "#D7FFF4", fontFamily: "Inter600"
                                                },
                                            }}
                                        >
                                            {category.name}
                                        </Button>
                                    </Grid2>
                                ))}
                            </Grid2> */}

                           <TextField
                                select
                                fullWidth
                                value={value}
                                onChange={handleChangeDropDown}
                                variant="outlined"
                                inputProps={{
                                    "aria-label": "Sub Category",
                                }}
                                SelectProps={{
                                    IconComponent: (props) => (
                                        <KeyboardArrowDownIcon {...props} sx={{
                                            color: '#000000 !important',
                                            pointerEvents: 'none'
                                        }} />
                                    ),
                                    MenuProps: {
                                        PaperProps: {
                                            sx: {
                                                borderRadius: "12px",
                                                backgroundColor: "#fff", // dropdown background
                                                fontFamily:"Inter400",
                                                color:"#000000"
                                            },
                                        },
                                      },
                                }}
                                sx={{
                                    margin: '15px 0px',
                                    '& .MuiOutlinedInput-root': {
                                        borderRadius: '12px',
                                        border: "2px solid white",
                                        boxShadow: "0px 4px 4px 0px #E8B889",
                                        // boxShadow: ` 0px 4px 62px 0px #00000040`,
                                        '& fieldset': { border: 'none' },
                                    },
                                    '& .MuiSelect-select': {
                                        color: "#000000",
                                        fontSize: 'calc(16px + var(--font-delta))',

                                        fontFamily: 'Inter400',
                                    },
                                    '& .MuiMenuItem-root.Mui-selected': {
                                        backgroundColor: 'rgba(255,255,255,0.1)',
                                        fontWeight: 700,
                                    },
                                }}
                            >
                                {subCategory.map((opt) => (
                                    <MenuItem key={opt.id} value={opt.name}>
                                        {opt.name}
                                    </MenuItem>
                                ))}
                            </TextField>
                        </Grid2>
                </> :<>
                        <Grid2 container
                            spacing={2} xs={12} md={3}
                            sx={{
                                pr: 2, display: "flex", flexDirection: "column", minWidth: "200px"
                                , "@media screen (max-width:900px)": {
                                    flexDirection: "row",
                                    minWidth: "0px"
                                }
                            }}

                        >


                        {
                            isSmallScreen ? <>
                                    <Grid2 container display="flex" justifyContent="space-between">
                                        <Grid2 item>
                                            <Typography className={Styles.jmptotxt}>
                                                Jump to
                                            </Typography>
                                        </Grid2>

                                        <Grid2 item sx={{ paddingTop: "5px" }}>
                                            <Button
                                                onClick={handleBackClick}
                                                variant="text"
                                                sx={{
                                                    padding: '0px 0px',
                                                    textTransform: 'none',
                                                    fontFamily: 'Inter600',
                                                    fontWeight: 400,
                                                    fontSize: 'calc(20px + var(--font-delta))',
                                                    color: '#CB2F3F',
                                                    '&:hover': {
                                                        backgroundColor: 'transparent',
                                                    },
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                }}
                                            >
                                                <ArrowBackIcon sx={{ marginRight: '8px', color: '#CB2F3F' }} />
                                                Back
                                            </Button>
                                        </Grid2>
                                    </Grid2>
                            </>:<>
                                        <Typography className={Styles.jmptotxt} >
                                            Jump to
                                        </Typography>
                            </>
                        }
                            {/* */}


                            <Grid2 container spacing={2} >
                                {subCategory.map((category, index) => (
                                    <Grid2 item key={category.id}>
                                        <Box className={Styles.cardWrapper} sx={{ width: "fit-content" }}>
                                        <Button
                                            onClick={() => {
                                                setExpanded(null)
                                                setSelected(category.id);
                                                handleListFaqs(category.id);
                                                handleSubCategoryRoute(category.name)
                                            }}
                                            sx={{
                                                width: "216px",
                                                height: category.id === selected ? "71px" : "47px",
                                                borderRadius: "22px",
                                                textTransform: "capitalize",
                                                // border: "1px solid #D3D3D3",

                                                fontFamily:
                                                    category.id === selected ? "Inter600" : "Inter400",
                                                color: category.id === selected ? "#ffffff" : "#000000",

                                                background: category.id === selected ? "linear-gradient(252.52deg, #110A0A 9.37%, #2D1F1C 47.3%, #2F2F0A 73.59%, #171346 99.03%)":"#DAD4C666",
                                                marginBottom: "15px",
                                                // padding:"12px 17px",
                                                // boxShadow: category.id === selected ? "0px 4px 62px 0px #00000040" : "",

                                                // "&:hover": {
                                                //      fontFamily: "Inter600"
                                                // },
                                            }}
                                        >

                                                <span
                                                    className={`${Styles.circleBackground} ${category.id === selected ? Styles.activeCircle : ""
                                                        }`}
                                                ></span>
                                                <span style={{ position: 'relative', zIndex: 3, fontSize:"calc(14px + var(--font-delta))" }}>{category.name}</span>
                                            {/* {category.name} */}
                                        </Button>
                                        </Box>
                                    </Grid2>
                                ))}
                            </Grid2>
                        </Grid2>
                        </>
            }


                {/* right Sidebar  */}
            <Grid2 item xs={12} md={9} className={Styles.all_top} >
                <Grid2 container display="flex" justifyContent="space-between">
                    <Grid2 item>
                        <Typography className={Styles.jmptotxt} mb={3}>
                            All About Trading
                        </Typography>
                    </Grid2>

                        {
                            isSmallScreen ? <></> : <>
                                <Grid2 item>
                                    <Button
                                        onClick={handleBackClick}
                                        variant="text"
                                        sx={{
                                            padding: '0px 20px',
                                            textTransform: 'none',
                                            fontFamily: 'Inter500 !important',
                                            fontWeight: 400,
                                            fontSize: 'calc(20px + var(--font-delta))',
                                            color: '#CB2F3F',
                                            '&:hover': {
                                                backgroundColor: 'transparent',
                                            },
                                            display: 'flex',
                                            alignItems: 'center',
                                        }}
                                    >
                                        <ArrowBackIcon sx={{ marginRight: '8px', color: '#CB2F3F' }} />
                                        Back
                                    </Button>
                                </Grid2>
                                </>
                        }


                </Grid2>


                {faqsList.map((faq, index) => (
                    <div key={faq.id} ref={(el) => faqRefs.current[faq.id] = el}>
                        <Divider sx={{ background: "rgba(255, 255, 255, 0.2)" }} />

                        <Accordion
                            expanded={expanded === index}
                            onChange={(e, isExpanded) => {
                                setFaqId(faq.id)
                                handleChange(isExpanded, index)
                                handleSubCategoryFaqRoute(faq.question)
                            }}
                            sx={{
                                background: "transparent",
                                boxShadow: "none",
                                color: "white",
                                margin: 0,
                            }}
                        >
                            <AccordionSummary
                                expandIcon={
                                    expanded === index ? (
                                        <HighlightOffIcon sx={{ color: "#000000", opacity: 0.4 }} />
                                    ) : (
                                        <AddCircleOutlineIcon sx={{ color: "#000000", opacity: 0.4  }} />
                                    )
                                }
                                sx={{ padding: "16px 0" }}
                            >
                                <Typography className={Styles.faq_qstn}>{faq.question}</Typography>
                            </AccordionSummary>
                            <AccordionDetails sx={{ paddingBottom: "20px" }}>
                                {/* Render rich text (HTML) - srini - 09/05/25 */}
                                {/<[a-z][\s\S]*>/i.test(faq.answer) ? (
                                    <div
                                        className={Styles.faq_ansr}
                                        dangerouslySetInnerHTML={{ __html: faq.answer }}
                                    />
                                ) : (
                                    faq.answer.split("\n\n").map((paragraph, idx) => {
                                        const isBulletPoint = paragraph.startsWith("●");
                                        return (
                                            <Typography
                                                key={idx}
                                                sx={{
                                                    opacity: 0.8,
                                                    marginBottom: "12px",
                                                    display: isBulletPoint ? "list-item" : "block",
                                                    pl: isBulletPoint ? "5px" : "0",
                                                }}
                                                className={Styles.faq_ansr}
                                            >
                                                {paragraph.replace(/^●\s*/, "")}
                                            </Typography>
                                        );
                                    })
                                )}

                                {/* Render below section only if this FAQ is expanded */}
                                {relatedFaqs.length > 0 && (
                                    <Grid2 container direction="column" mt={5} spacing={1}>
                                        <Grid2 item>
                                            <Typography className={Styles.jmptotxt}>
                                                Related articles
                                            </Typography>
                                        </Grid2>

                                        <Grid2 item>
                                            <List>
                                                {relatedFaqs.map((relatedFaq) => (
                                                    <ListItem key={relatedFaq.id} button onClick={() => handleFaqClick(relatedFaq)}>
                                                        <ListItemText
                                                            primary={relatedFaq.question}
                                                            primaryTypographyProps={{
                                                                sx: {
                                                                    color: '#368DFF',
                                                                    fontFamily: 'Inter400',

                                                                    fontSize: 'calc(20px + var(--font-delta))',
                                                                    lineHeight: '30px',
                                                                    letterSpacing: '0.38px',
                                                                }
                                                            }}
                                                        />
                                                    </ListItem>
                                                ))}
                                            </List>
                                        </Grid2>
                                    </Grid2>
                                )}

                                {/* Always show this section */}
                                <Grid2 container direction="column" mt={8} spacing={1}>
                                    <Grid2 item>
                                        <Typography className={Styles.help} sx={{ color: "#F5F1EB" }}>
                                            Still need help?
                                        </Typography>
                                    </Grid2>

                                    <Grid2 item>
                                        <Button
                                            onClick={handleCreateTicket}
                                            variant="contained"
                                            sx={{
                                                width: "213px",
                                                height: "56px",
                                                borderRadius: "50px",
                                                fontFamily: 'Inter500',
                                                fontSize: 'calc(18px + var(--font-delta))',
                                                lineHeight:"24px",
                                                textTransform: 'none',
                                                background: "linear-gradient(90deg, #E93333 0%, #6A2066 100%)",
                                                color: "#ffffff",
                                                '&:hover': {
                                                    background: "linear-gradient(90deg, #E93333 0%, #6A2066 100%)",
                                                },
                                            }}
                                        >
                                            Create A Ticket
                                        </Button>
                                    </Grid2>
                                </Grid2>
                            </AccordionDetails>
                        </Accordion>

                        <Divider sx={{ background: "rgba(255, 255, 255, 0.2)" }} />
                    </div>
                ))}


            </Grid2>
        </Grid2>
        </Grid2>
    </main>)
}